import { inject, injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { GeolocationRepository } from "src/shared/repositories/geolocation/geolocation-repository";
import { GeographicLocation } from "src/shared/types/entities";

export interface IGeolocationService {
    getGeoLocations(): Promise<GeographicLocation[]>;
}

@injectable()
export class GeolocationService implements IGeolocationService {
    constructor(
        @inject("GeolocationRepository") private repo: GeolocationRepository
    ) {}

    @autoBind
    getGeoLocations(): Promise<GeographicLocation[]> {
        return this.repo.getGeoLocations().toPromise();
    }
}
